import { Link, withRouter } from "react-router-dom";
import Navigation from "../navigation/Navigation";
import { useCart, useCartDispatcher } from "../../context/CartProvider";
import { checkInCart } from "../../utils/chackInCart";
import { BiCartAlt, BiChevronsRight, BiMoon, BiSun, BiUser } from "react-icons/bi";
import { products } from "../../Products";
import Slider from "react-slick";
import "../../../node_modules/slick-carousel/slick/slick.css"; 
import "../../../node_modules/slick-carousel/slick/slick-theme.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useEffect } from "react";
import { useState } from "react";
import { MdLanguage } from "react-icons/md";
import i18next from "i18next";
// import "./style.css"
// import { BiChevronsRight } from "react-icons/bi";
const productss = products;
const categoryName =['kids', 'comedy','love','cooking','classic']

const Product = ({ location, setTheme, theme ,changeLanguage}) => {
  const [menu , setMenu]=useState(false)

  console.log(location);
  const dispatch = useCartDispatcher();

  const { cart } = useCart();

  const AddClickHandler = (todo) => {
    dispatch({ type: "ADD-TO-CART", payload: todo });
  };
  const productId = location.pathname.match(/\d+/)[0];
  const product = productss.find((p) => p.id.toString() === productId);
  function SampleNextArrow(props) {
    const { onClick } = props;
    return (
      <div
        className="slick-arrow absolute z-10  top-[70px] y9:top-[85px] md:top-[90px] lg:top-[105px] right-[-20px] lg:right-[-3px] "
          onClick={onClick}
      >
     <div className="flex justify-center  rounded-[50%] bg-black bg-opacity-50 w-[35px] h-[35px] md:w-[50px] md:h-[50px]  cursor-pointer text-[16px] md:text-[19px] 
     hover:text-[18px] hover:w-[37px] hover:h-[37px]  hover:md:text-[21px] hover:md:w-[52px] hover:md:h-[52px] hover:bg-opacity-60 duration-100  ">
  
  <FaChevronRight className="text-white  self-center  "/>  
  </div>
     </div>
    );
  }
  
  function SamplePrevArrow(props) {
    const { onClick } = props;
    return (
      <div
        className="slick-arrow absolute z-10 top-[70px] y9:top-[85px] md:top-[90px] lg:top-[105px] left-[-20px] lg:left-[-30px] "
        onClick={onClick}
      >
        <div className="flex justify-center  rounded-[50%] bg-black bg-opacity-50 w-[35px] h-[35px] md:w-[50px] md:h-[50px]  cursor-pointer text-[16px] md:text-[19px] 
        hover:text-[18px] hover:w-[37px] hover:h-[37px]  hover:md:text-[21px] hover:md:w-[52px] hover:md:h-[52px] hover:bg-opacity-60 duration-100 
  ">
        <FaChevronLeft className="text-white  self-center  "/>  
        </div>
      </div>
    );}
  const settings = {
    className: "center",
    infinite: true,
    centerPadding: "60px",
    slidesToShow: 5,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    swipeToSlide: true, 
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          // slidesToScroll: 4,
          infinite: true,
          // dots: true
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          // initialSlide: 3,
          infinite: true,
          // dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          // initialSlide: 3,
          infinite: true,
          // dots: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          // slidesToScroll: 3,
          infinite: true,
          // dots: true
        }
      },
      {
        breakpoint: 350,
        settings: {
          slidesToShow: 2,
          // slidesToScroll: 3,
          infinite: true,
          // dots: true
        }
      }
    ]
    };
    const [IsLogin, setIsLogin] = useState([]);
    const IsSingup = localStorage.getItem("user");
    useEffect(() => {
      setIsLogin(localStorage.getItem("user"));
    }, []);
  
    useEffect(() => {
      if (IsSingup) {
        setIsLogin(IsSingup);
      } else {
        setIsLogin([]);
      }
    }, [IsSingup]);
  return (
    <div className="">
      <div className=" z-10 sticky top-0  backdrop-filter backdrop-blur-md bg-opacity-70 ">
      <div className=" z-30 sticky top-0  ">
        <Navigation setTheme={setTheme} theme={theme} menu={menu} setMenu={setMenu} changeLanguage={changeLanguage} />
      </div>
      </div>
      <div className="flex justify-center  text-Darktext dark:text-white ">
        <div className="flex flex-col y9:w-[535px] sm:w-[635px] md:w-[760px] lg:w-[1024px] mt-10 ">
          <div className="  text-Darktext dark:text-white  text-[17px] mx-5 mt-5 mb-8 flex ">
            <Link to={"/"} className="self-center text-thertext dark:text-[#717374]  mr-1">
              Home
            </Link>
            <span className="self-center text-[#717374] mr-1 ">
              <BiChevronsRight />
            </span>
            <Link
              to={`/${product.category}`}
              className="self-center text-[#717374] cursor-pointer mr-1"
            >
              {product.category}
            </Link>
            <span className="self-center text-[#717374] mr-1 ">
              <BiChevronsRight />
            </span>
            <span className="font-semibold">{product.title}</span>
          </div>
          <div className="flex  sm:justify-center sm:p-5 border-[2px] rounded-md shadow-lg dark:border-[#363636] dark:bg-Darksecondcolor bg-secondcolor">
            <div className="sm:w-[250px] mx-2 y9:mx-5 sm:mx-10">
              <div className="flex justify-center mb-5">
                <div className="flex justify-center">
                  <div className="container hidden  sm:flex">
                
                    <img
                      src={product.image}
                      alt=""
                      className="image shadow-xl"
                    />
                  </div>
                </div>
              </div>
              <div className="hidden sm:flex justify-center">

              {checkInCart(cart, product) ? (
                <div className="  flex justify-center ">
                  <button
                    disabled={true}
                    className="border font-semibold border-[#417ed4] sm:text-[18px] px-8 sm:px-[70px] mt-3  rounded-md  py-[7px] text-[#417ed4]"
                  >
                    In Cart
                  </button>
                </div>
              ) : (
                <div className="flex justify-center">
                  <button
                    onClick={() => AddClickHandler(product)}
                    className="bg-[#417ed4]   text-white font-semibold  px-4 sm:px-[70px]  duration-300
                     hover:rounded-xl mt-3  rounded-md  py-[7px]"
                  >
                    Add to cart
                  </button>
                </div>
              )}
              </div>
            </div>

            <div className="flex flex-col  sm:w-[650px] mt-16">
            <div className="w-full sm:hidden flex justify-center pb-10">
                
                <img
                  src={product.image}
                  alt=""
                  className="image shadow-xl w-[250px] self-center"
                />
              </div>
              <div className="mx-7 sm:m-0">
                <h1 className="font-bold text-[25px]">{product.title}</h1>
              </div>
              <div className="  dark:text-[#d1d2d2] mx-7 sm:m-0">
                author : {product.Author}
              </div>
              <div className="sm:hidden mx-7 sm:m-0">

{checkInCart(cart, product) ? (
  <div className="   ">
    <button
      disabled={true}
      className="border font-semibold border-[#417ed4] sm:text-[18px] px-8
       sm:px-[70px] mt-3  rounded-md  py-[7px] text-[#417ed4]"
    >
      In Cart
    </button>
  </div>
) : (
  <div>
    <button
      onClick={() => AddClickHandler(product)}
      className="bg-[#417ed4]  text-white font-semibold sm:text-[18px] px-8 sm:px-[70px] hover:sm:px-[75px]
       hover:py-2 duration-300 hover:rounded-lg mt-3  rounded-md  py-[7px]"
    >
      Add to cart
    </button>
  </div>
)}
</div>

              <div className="mt-20 border-b mb-5 pb-5 dark:border-[#363636] mr-2 y9:mr-10 sm:mx-0">
                <div>
                  <h2 className="font-semibold text-[20px]">Describation</h2>
                </div>
                <div className="dark:text-[#d1d2d2]">
                  {product.describtion} Lorem ipsum dolor, sit amet consectetur
                  adipisicing elit. Officia optio vero magni aspernatur ipsum,
                  atque non sed dolore praesentium provident ullam debitis
                  eligendi a. Libero aliquid at ratione veniam est.
                </div>
              </div>
              <div>
                <div className="font-semibold text-[18px]">Details</div>
                <div className="dark:text-[#e0e0e0]">
                  <div>publishData : {product.publishData}</div>
                  <div>pages : {product.pages}</div>
                  <div>dimensions : {product.dimensions}</div>
                </div>
              </div>
            </div>


            
          </div>

          <div className="self-center mt-40 border-2 dark:border dark:bg-Darksecondcolor dark:border-[#363636] px-8 py-3 rounded-md">
            <div className="flex flex-col  self-center rounded-sm">
              <div className="flex justify-between">
                <p className="mt-2 ml-4 text-[20px] font-semibold">
                  Here are some of our favorite<Link className="inline text-btnMain  "  to={`/${product.category}`}>  <span> {product.category}</span></Link> books
                </p>
                <Link to={`/${product.category}`}>
                  <p className="text-[#417ed4] font-semibold text-[17px] pt-2 ">view All</p>
                </Link>
              </div>

              <div className="flex">
              <div className="flex justify-center  dark:bg-Darksecondcolor bg-lightscreen self-center rounded-sm
p-3 px-5 md:px-8 ">
  <div className="max-w-[1170px] w-[75vw]   ">
    
        <Slider {...settings}>
         
        {products.map((p) => (
          p.category===product.category ?
                    <div className="self-center">
                      <Link
                        to={`/${p.category}/${p.id}`}
                        className="self-center mb-4 "
                      >
                        <img
                          src={p.image}
                          alt=""
                          className="  px-1 w-[180px] min-w-[130px] self-center  rounded-sm
                          hover:scale-105 hover:rounded-md ease-in-out  duration-300
         
                          "
                        />
                      </Link>
                    </div>
                    :
                    null
                  ))}

        </Slider>
      </div>

 </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div 
              onClick={(e)=>{ e.preventDefault();setMenu(false) }}
              className={` ${!menu && "scale-x-0"} ${i18next.language==="en"?"origin-right " : "origin-left"} duration-300 absolute w-[100%] h-[1400px] z-30  top-0 dark:bg-opacity-60 dark:bg-black backdrop-blur-md bg-lightscreen bg-opacity-40 `}></div>
              <div/>


              <div 
              className={`absolute top-16 z-40 ${i18next.language==="en" ? "right-0" : "left-0"} top-10 ${!menu && "scale-x-0"} ${i18next.language==="en"?"origin-right border-l  w-48 pb-8" : "origin-left border-r w-48 pb-8"}  border-border 
              duration-300 flex flex-col justify-center text-[17px] pt-5 dark:text-white text-black  font-semibold  `}>
                {IsLogin.length===0 ? 
              <div className="self-center">
              <Link to={"/login"} className="bg-btnMain text-white px-12  text-[17px] rounded-sm hover:rounded-md hover:px-14 duration-300 py-2 my-2"
              >Login</Link>

            </div>
            :

                  <div className="py-6 flex mx-2 border-b cursor-pointer  border-border w-28 hover:text-[18px] duration-200 ">
                    <div className="self-center mx-2 text-[21px]"><BiUser/> </div>
                    <div>User</div>
                  </div>
              }
                
                <div className="py-6 flex mx-2 cursor-pointer  border-b border-border w-28 hover:text-[18px] duration-200">
                  <div className="self-center mx-2 text-[21px]"><BiCartAlt/></div>
                  <Link to={"/cart"}>Cart</Link>
                </div>
                <div className="py-6 flex mx-2  border-b border-border w-28 hover:text-[18px] duration-200">
                <div
                
                className="self-center cursor-pointer mx-2 text-[22px]">
                  {theme==="lightTheme" ? <BiMoon onClick={()=>{setTheme("darkTheme")}}/> : <BiSun onClick={()=>{setTheme("lightTheme")}}/> }
                  </div>
                  <div>Theme</div>
                </div>
                <div 
                onClick={()=>changeLanguage() }
                className="py-6 flex mx-2 cursor-pointer y9:border-0 border-b border-border hover:text-[18px] duration-200">
                  <div className="self-center mx-2 text-[21px] ">
                    <MdLanguage/> 
                    </div>
                  <div>
                    {i18next.language==="en" ? "فا" :"En"}
                  </div>
                </div>
                <div className="mx-2 flex flex-col y9:hidden">
                  {categoryName.map(category=>
                  <Link to={`/${category}`}>
                  <div  className="py-6 text-[18px] mx-2 border-b border-border w-28 hover:text-[18px] duration-200 ">{category}</div>
                  </Link>
                  )}
                </div>
              </div>

    </div>
  );
};

export default withRouter(Product);
